import React, { FC } from 'react';
import { TermsWrapper, TermsText, SvTermsWrapper, TermsLink, TermsError } from './TermsOfUse.styles';
import { Box } from '@mui/system';
import { CustomCheckBox } from '../../../../common/components/CustomCheckBox/CustomCheckBox';
import { EventNames } from '../../../../common/constants/constants';
import { useClientType } from '../../../../services/hooks/useClientType';
import { useTrackEvent } from '../../../../common/hooks/useTrackEvent';
import { SignUpScreenStrings } from '../../../../common/localization/en';
import {
  PRIVACY_POLICY_LINK_TRUBLU,
  SV_USER_TERMS,
  TERMS_OF_SERVICE_LINK_TRUBLU,
} from '../../../../common/components/AuthForm/AuthForm.helper';

interface Props {
  isTermsAccepted: boolean | null;
  onChange: (isChecked: boolean | null) => void;
}

export const TermsOfUse: FC<Props> = ({ onChange, isTermsAccepted }) => {
  const { trackEvent } = useTrackEvent();
  const { isTrubluClient } = useClientType();

  return (
    <Box>
      <TermsWrapper>
        <CustomCheckBox
          isChecked={isTermsAccepted || false}
          onChange={(_, isChecked) => {
            onChange(isChecked);
            trackEvent({ action: EventNames.Sv_Tos_Checkbox_Click });
          }}
        />
        {isTrubluClient ? (
          <TermsText display="inline">
            {SignUpScreenStrings.Accept}
            <TermsLink href={TERMS_OF_SERVICE_LINK_TRUBLU} target="_blank" rel="noreferrer">
              {SignUpScreenStrings.TermsOfUse}
            </TermsLink>
            {SignUpScreenStrings.Ampersand}
            <TermsLink href={PRIVACY_POLICY_LINK_TRUBLU} target="_blank" rel="noreferrer">
              {SignUpScreenStrings.PrivacyPolicy}
            </TermsLink>
          </TermsText>
        ) : (
          <TermsText display="inline">
            {SignUpScreenStrings.YouAgree}
            <TermsLink
              href={SV_USER_TERMS}
              target="_blank"
              rel="noreferrer"
              style={{
                fontWeight: 500,
              }}
            >
              {SignUpScreenStrings.UserTerms}
            </TermsLink>
            {SignUpScreenStrings.Ampersand}
            <TermsLink
              href={SV_USER_TERMS}
              target="_blank"
              rel="noreferrer"
              style={{
                fontWeight: 500,
              }}
            >
              {SignUpScreenStrings.PrivacyPolicy}
            </TermsLink>
          </TermsText>
        )}
      </TermsWrapper>
      {isTermsAccepted === false && (
        <TermsError>{SignUpScreenStrings.CheckTheBox}</TermsError>
      )}

      {isTrubluClient && (
        <SvTermsWrapper>
          <TermsText display="inline" textAlign="center">
            {SignUpScreenStrings.ByProceeding}
            <TermsLink
              href={SV_USER_TERMS}
              target="_blank"
              rel="noreferrer"
              style={{
                fontWeight: 500,
              }}
            >
              {SignUpScreenStrings.UserTerms}
            </TermsLink>
            <br />
            {SignUpScreenStrings.Ampersand}
            <TermsLink
              href={SV_USER_TERMS}
              target="_blank"
              rel="noreferrer"
              style={{
                fontWeight: 500,
              }}
            >
              {SignUpScreenStrings.PrivacyPolicy}
            </TermsLink>
          </TermsText>
        </SvTermsWrapper>
      )}
    </Box>
  );
};
